import React,{useReducer,useEffect} from 'react';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
import ButtonCollection from './ButtonCollection';

const DragHandle = SortableHandle(() => <div class="sorter_target" />);

const SortableFields = SortableContainer(({ items, data,...props }) => {
	const not_bordered_top = props?.not_bordered_top ?? false;

	const classes = ['gui_sortable_list', 'gui_flexbox', 'gui_flex_start', 'gui_flex_col', 'gui_flex_nowrap', 'gui_custom_fields_list'];
	if(not_bordered_top) classes.push('not_bordered_top');

	return (
		<ul class={classes.join(" ")} style={{ borderBottom:'1px solid rgba(var(--main-text-color), 0.4)' }}>
			{items.map((item, index)=> {
				if(item == undefined) return null;

				return (
					<SortableItem
						key={index}
						index={index}
						item={item}
						{...data}
						dispatch={props.dispatch}
					/>
				)
			})}
		</ul>
	);
});

const SortableItem = SortableElement((props) => {
	const field = props.field;

	const change = (k, v) => {
		props.dispatch({ type:'CHANGE_VALUE', id:field.id, k, v });
	};

	return (
		<li class="gui_sortable_list_item gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap gui_flex_align_center">
			<div class="item_header">
				<DragHandle />

				<div class="item_title_container">
					{props.item.title != undefined && props.item.title()}
				</div>

				{/* <div style={{flexGrow:'1'}}>
					<strong class="gui_pos_rel gui_flexbox" style={{height:'1.5em'}}>
						<ActionLink onClick={() => props.dispatch({type:'SETOPEN', id:field.id})} _class={{other:'gui_cutTextOnOverflow'}} autotranslate={false}>{title}</ActionLink>
					</strong>
				</div>

				 */}
				{(props.actions != undefined) ? (
					React.cloneElement(props.actions, { item:props.item})
				) : (
					<ButtonCollection />
				)}
			</div>

			{(props.open != undefined && props.open(props.item)) && (
				<div class="gui_item_unfoldable_options">
					{React.cloneElement(props.element, { item:props.item})}
				</div>
			)}
		</li>
	)
});

const SortableItems = ({items,...props}) => {
	const [ state, dispatch ] = useReducer((state, action) => {
		switch (action.type) {
			case 'SORT':
				let new_order = arrayMove(state.items, action.oldIndex, action.newIndex);
				if(props.onChange != undefined) props.onChange(new_order);
				return { ...state, items:[ ...new_order ] };

			case 'DELETE':
				let newstate = {...state,fields:state.fields.filter(f=>f.id != action.id)}
				if(props.onChange != undefined) props.onChange(newstate.fields);
				return newstate;

			case 'SETOPEN':
				return {...state,open:action.id == state.open ? false : action.id};

			case 'CHANGE_VALUE':
				for (var i in state.fields) {
					if (state.fields[i].id != action.id ) continue;
					state.fields[i] = {...state.fields[i],[action.k]:action.v};
					if(props.onChange != undefined) props.onChange(state.fields);
					return {...state,fields:[...state.fields]};
				}
				return state;

			case 'SET_ITEMS':
				return {...state,items:action.items};

			default:
				return state;
		}
	}, { items:items, open:false });

	useEffect(() => {
		if(props.onChange != undefined) props.onChange(state.items);
	}, []);

	useEffect(() => {
		dispatch({type:'SET_ITEMS',items})
	}, [items]);

	const onSortEnd = ({oldIndex, newIndex}) => {
		dispatch({type:'SORT', oldIndex, newIndex});
	}

	return (
		<>
			<SortableFields
				items={state.items}
				data={{
					element:props.children,
					actions:props.actions,
					open:props.open
				}}
				not_bordered_top={props.not_bordered_top}
				useDragHandle={true}
				onSortEnd={onSortEnd}
				dispatch={dispatch}
			/>
		</>
	)
}

export default SortableItems;